import PlatformService from '../Services/PlatformDBService';

export const closeAllServices = async () => {
  console.log('AZED: Closing all services, preparing for reload/shutdown');
  // close all existing db connn
  const instance = await PlatformService.getInstance();
  await instance.closeConnection();
  console.log('AZED: All existing db connn closed');
};

// RESTART SYSTEMS
export const restartSystems = async (onBeforeReload?: () => void) => {
  try {
    console.log('AZED: Restarting systems...');
    await closeAllServices();
  } catch (error) {
    console.error('AZED: Error closing all services before restart :', error);
  } finally {
    try {
      onBeforeReload?.();
    } finally {
      window.location.reload();
    }
  }
};
// TODO: Review this function
